const prefix = "agentspace.workspace-view.v1:";
const tools = new Set([
  "browser",
  "terminal",
  "files",
  "activity",
  "coding",
  "media",
  "context",
]);

export function workspaceViewKey({ tenantId, userId, workspaceId, projectId }) {
  return [tenantId, userId, workspaceId].every(
    (value) => typeof value === "string" && value,
  )
    ? JSON.stringify([tenantId, userId, projectId || null, workspaceId])
    : null;
}

export function workspaceView(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  const state = {};
  if (Array.isArray(value.tabs))
    state.tabs = [...new Set(value.tabs.filter((tab) => tools.has(tab)))];
  if (tools.has(value.active) || value.active === null)
    state.active = value.active;
  for (const name of ["filePath", "browserPath", "terminalId"])
    if (typeof value[name] === "string" && value[name].length <= 2048)
      state[name] = value[name];
  if (["workspace", "live", "web"].includes(value.browserMode))
    state.browserMode = value.browserMode;
  if (["fluid", "390", "768", "1280"].includes(value.previewSize))
    state.previewSize = value.previewSize;
  if (["right", "bottom"].includes(value.dockPosition))
    state.dockPosition = value.dockPosition;
  if (typeof value.dock === "boolean") state.dock = value.dock;
  for (const name of ["dockWidth", "dockHeight"])
    if (
      Number.isFinite(value[name]) &&
      value[name] >= 240 &&
      value[name] <= 2000
    )
      state[name] = value[name];
  return state;
}

/** Only view preferences are durable; file contents and execution authority are not. */
export function createWorkspaceState({ storage } = {}) {
  if (storage === undefined) {
    try {
      storage = globalThis.localStorage;
    } catch {
      storage = null;
    }
  }
  const memory = new Map();
  const failedWrites = new Set();
  return {
    read(key) {
      if (!key) return {};
      if (failedWrites.has(key)) return memory.get(key) || {};
      try {
        const raw = storage?.getItem(prefix + key);
        if (raw) return workspaceView(JSON.parse(raw));
      } catch {
        /* Storage may be unavailable. */
      }
      return memory.get(key) || {};
    },
    write(key, patch) {
      if (!key) return;
      const state = { ...this.read(key), ...workspaceView(patch) };
      memory.set(key, state);
      try {
        storage?.setItem(prefix + key, JSON.stringify(state));
        failedWrites.delete(key);
      } catch {
        failedWrites.add(key);
      }
    },
  };
}
